import React from 'react';
import { Box, Flex } from '@chakra-ui/react';
import type { CarouselApi } from '@/components/ui/Carousel';
import LucideIcon from '@/components/ui/LucideIcon';

interface CarouselNavigationProps {
  api: CarouselApi | undefined;
  activeIndex: number;
  totalItems: number;
  onPrevClick?: () => void;
  onNextClick?: () => void;
  onDotClick?: (index: number) => void;
}

const CarouselNavigation = ({
  api,
  activeIndex,
  totalItems,
  onPrevClick,
  onNextClick,
  onDotClick,
}: CarouselNavigationProps) => {
  const handlePrevClick = () => {
    if (onPrevClick) {
      onPrevClick();
    } else {
      api?.scrollPrev();
    }
  };

  const handleNextClick = () => {
    if (onNextClick) {
      onNextClick();
    } else {
      api?.scrollNext();
    }
  };

  const handleDotClick = (index: number) => {
    if (onDotClick) {
      onDotClick(index);
    } else {
      api?.scrollTo(index);
    }
  };

  return (
    <Flex alignItems="center" gap={6} justifyContent="center" width="100%" marginTop={6}>
      <Flex
        alignItems="center"
        cursor="pointer"
        justifyContent="center"
        onClick={handlePrevClick}
        padding={2}
        transition="all 0.2s"
        _hover={{
          borderColor: 'neutral.80',
          transform: 'translateX(-4px)',
        }}
      >
        <LucideIcon name="MoveLeft" width={54} height={24} color="neutral.100" strokeWidth={1} />
      </Flex>

      <Flex alignItems="center" gap={1}>
        {Array.from({ length: totalItems }, (_, index) => (
          <Box
            key={index}
            width={activeIndex === index ? 5 : 3}
            height={1}
            backgroundColor={activeIndex === index ? 'neutral.100' : 'neutral.10'}
            borderRadius={activeIndex === index ? '4px' : 'full'}
            cursor="pointer"
            transition="all 0.2s"
            onClick={() => handleDotClick(index)}
            _hover={{ backgroundColor: activeIndex === index ? 'brand.50' : 'neutral.30' }}
          />
        ))}
      </Flex>

      <Flex
        alignItems="center"
        cursor="pointer"
        justifyContent="center"
        onClick={handleNextClick}
        padding={2}
        transition="all 0.2s"
        _hover={{
          borderColor: 'neutral.80',
          transform: 'translateX(4px)',
        }}
      >
        <LucideIcon name="MoveRight" width={54} height={24} color="neutral.100" strokeWidth={1} />
      </Flex>
    </Flex>
  );
};

export default CarouselNavigation;
